export default {


    methods: {
        jumpReview(e) {
            e.preventDefault();

            let url = this.page_state.locale_url;
            url += "/review";
            url += "?category=" + this.page_state.category;
            url += "&id=" + this.item_id;

            window.location.href = url;
        },

    },

};
